import { IHouseBTIDataSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { numberToPrettyString } from '@cian/utils';

export function getCianPriceRange(houseData: IHouseBTIDataSchema): string | null {
  const priceCian = Number(houseData.priceCian);
  const priceCianMin = Number(houseData.priceCianMin);
  const priceCianMax = Number(houseData.priceCianMax);

  const price = [];
  const nbsp = '\u00A0';

  if (priceCianMin) {
    price.push(`${numberToPrettyString(Math.round(priceCianMin))} \u20BD`.replace(/ /g, nbsp));
  }

  if (priceCianMax) {
    price.push(`${numberToPrettyString(Math.round(priceCianMax))} \u20BD`.replace(/ /g, nbsp));
  }

  if (price.length === 0 && priceCian) {
    price.push(`${numberToPrettyString(Math.round(priceCian))} \u20BD`.replace(/ /g, nbsp));
  }

  return price.length ? `${price.join(' – ')}` : null;
}
